// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IHO4X","label":"styles_label__1Znat"};